/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".ty-min-height[_ngcontent-%COMP%]{min-height:350px}.subhead-header[_ngcontent-%COMP%]{margin-top:30px}"];
export { styles as styles };

